// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__17J36","fileDisabled":"File_fileDisabled__E8X6_"};